export default {
    top_menu: [
        {name:'Galvenais',    id:0},
        {name:'Šovbizness', id:1},
        {name:'Ēdienu gatavošana',  id:2},
        {name:'Politika',   id:3},
        {name:'Pikants',  id:4},
        {name:'Sabiedrība',   id:5},
        {name:'Veselība',   id:6},
    ],
    read_other: 'Lasīt vairāk',
    read_more:  'Skatīt vairāk',
    not_found:  'Nekas nav atrasts',
    read_also:  'Lasiet arī',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Visas tiesības aizsargātas.',
    subscribe: 'Abonēt',

    thank_order: 'PALDIES PAR JŪSU PASŪTĪJUMU',
    specialist_contact: 'Mūsu speciālists drīz sazināsies ar jums, gaidiet mūsu zvanu.',
    attention: 'Atlaides no partneriem:',
    hurry: 'Pasteidzieties, atlaižu aktivizācijas laiks ir ierobežots! Jums ir tikai <span id="time" class="time">30:00</span> minūtes, lai izvēlētos vienu no šiem unikālajiem produktiem:',

    hour_ago1: "Pirms stundas",
    hour_ago2: "pirms vairākām stundām",
    hour_ago3: "pirms vairākām stundām",
    new_publications: "Jaunas publikācijas",
    read: "Lasīt",
    today_at: "Šodien plkst",
    author_names: ['Markuss Riva','Lauris Reiniks','Kristaps Porziņģis'],
    main_news: "Galvenās ziņas",
    leave_already: "Jau aizbrauc? Pagaidiet, mēs esam jums atjauninājuši ziņas",
    already_shared: "jau kopīgots"

}